import { Helmet } from "react-helmet-async";

const BRAND = "Desp sas";
const DEFAULT_TITLE = "Desp sas | Noleggio Piattaforme Aeree ed Escavatori a Catania - DESP di Sandro Pace";

export const Seo = ({ title, description, path = "", image = "/images/hero.jpg", jsonLd }) => {
  const full = title ? `${title} | ${BRAND} Catania` : DEFAULT_TITLE;
  const origin = process.env.REACT_APP_SITE_URL || window.location.origin;
  const url = `${origin}${path}`;
  return (
    <Helmet>
      <html lang="it" />
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:image" content={`${origin}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${origin}${image}`} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
